export class UnknownUserError extends Error {
	constructor(message: string) {
		super(message);
		Object.setPrototypeOf(this, UnknownUserError.prototype);
	}
}
